import { ISingleUnitInitialPeriods } from '@llws/lift-entity-interfaces';
import React from 'react';

interface SingleUnitInitialPeriodsTableProps {
  data: ISingleUnitInitialPeriods[];
}

const SingleUnitInitialPeriodsTable: React.FC<SingleUnitInitialPeriodsTableProps> = ({ data }) => {
  return (
    <div style={{ marginTop: '20px', overflowX: 'auto' }}>
      <h3>Single Unit Initial Periods ({data.length} records)</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f5f5f5' }}>
            <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>ID</th>
            <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Building ID</th>
            <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Suite Type ID</th>
            <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Start Date</th>
            <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>End Date</th>
            <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Days</th>
          </tr>
        </thead>
        <tbody>
          {data.map(period => (
            <tr key={period.id}>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{period.id}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{period.buildingId}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{period.suiteTypeId || 'N/A'}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                {period.startDate ? period.startDate.substring(0, 10) : 'N/A'}
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                {period.endDate ? period.endDate.substring(0, 10) : 'N/A'}
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                {period.startDate && period.endDate ?
                  Math.floor(
                    (new Date(period.endDate).getTime() - new Date(period.startDate).getTime()) / (1000 * 60 * 60 * 24),
                  ) + 1 :
                  'N/A'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SingleUnitInitialPeriodsTable;
